import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import type { SubscriptionAdvertisement } from '../../@types/AdvertismentSubscription';
import {
  trackLoginModuleClickLoginSaveObject,
  trackLoginModuleInViewportSaveObject,
} from '../../actions/tracking';
import SubscriptionCreateModal from '../../components/subscriptions/ad-subscription-create-modal';
import SubscriptionRemoveModal from '../../components/subscriptions/ad-subscription-remove-modal';
import type { RootState } from '../../reducers';
import SignInModal from '../../styled-components/structures/Modals/SignInModal';
import { getAdvertisementSubscription, getSearchDocument } from '../../utils/reselectors';

interface PropsType {
  modalType?: string;
  onClose: () => void;
}

const SaveModal = ({ onClose, modalType }: PropsType) => {
  const { t } = useTranslation('item');
  const dispatch = useDispatch();

  const subscription = useSelector<RootState, SubscriptionAdvertisement | null | undefined>((s) =>
    getAdvertisementSubscription(s, getSearchDocument(s)),
  );

  const actions = bindActionCreators(
    {
      trackLoginModuleInViewportSaveObject,
      trackLoginModuleClickLoginSaveObject,
    },
    dispatch,
  );

  useEffect(() => {
    if (modalType === 'SIGN_IN') {
      actions.trackLoginModuleInViewportSaveObject();
    }
  }, [modalType]);

  switch (modalType) {
    case 'SUBSCRIBE':
      return <SubscriptionCreateModal onClose={onClose} />;
    case 'REMOVE':
      return <SubscriptionRemoveModal subscription={subscription} onClose={onClose} />;
    case 'SIGN_IN':
      return (
        <SignInModal
          image="/images/modal/save_assignment.png"
          title={t('You have to log in to save this car', { ns: 'item' })}
          text={t('loginModalDescription', { ns: 'loginModal' })}
          onClose={onClose}
          trackOnSignInClick={() => actions.trackLoginModuleClickLoginSaveObject()}
        />
      );
    default:
      return null;
  }
};

export default SaveModal;
